import { createFileRoute } from '@tanstack/react-router'
import { guardTeacherOnly } from '@/lib/auth/routeGuards'
import TeacherAttendanceManagement from '@/components/teacherPage/attendance/TeacherAttendanceManagement'

export const Route = createFileRoute('/teacher/attendance')({
  component: TeacherAttendanceManagement,
  beforeLoad: guardTeacherOnly,
})
